export default "__VITE_ASSET__BgImASHA__"